import { gql } from 'apollo-boost';

export const GET_ADMIN_ARTIFACT_DIAGNOSTIC = gql`
    query GetAdminArtifactDiagnostic($data: GetAdminArtifactDiagnosticInput) {
        getAdminArtifactDiagnostic(data: $data) {
            filters { limit status userId messageId semanticType }
            hasMore nextCursor
            sources {
                messageId ownerId messageTitle messageCaption sourceUrl createdAt candidateCount
                entityStatus entityVersion entityLastProcessedAt artifactStatus artifactVersion
                processingStatus processingTrigger processingAttempts processingError processingStartedAt processingLockedUntil modelsUsed
                sourceFrames { index urlIndex galleryIndex label imageUrl ocrText ocrExtracted }
                entities { name type confidence sourceFields }
            }
            entries {
                candidateId messageId ownerId messageTitle messageCaption sourceUrl title semanticTypes status extractionVersion
                locationHint providerQuery providerStatus providerReason providerMatchedTitle providerPlaceId
                evidence evidenceUrlIndex evidenceSlide evidenceImageUrl evidenceImageLabel sourceFrameCount
                sourceFrames { index urlIndex galleryIndex label imageUrl ocrText ocrExtracted }
                artifactId artifactTitle updatedAt
            }
        }
    }
`;
